<template>
  <span>
    <el-select v-model="localRegion" clearable @change="change">
      <el-option
        v-for="item in regionList"
        :key="item.region"
        :label="item.regionName"
        :value="item.region"
      />
    </el-select>
  </span>
</template>

<script>
import { describeRegions } from '@/api/channel-api.js'
export default {
  name: 'RegionList',
  props: {
    region: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'region',
    event: 'changeRegion',
  },
  data() {
    return {
      regionList: [],
      localRegion: this.region,
    }
  },
  watch: {
    region(val) {
      this.localRegion = val
    },
    localRegion(val) {
      this.$emit('changeRegion', val)
    },
  },
  created() {
    this.useRegionsList()
  },
  methods: {
    async useRegionsList() {
      try {
        const { result = {} } = await describeRegions()
        this.regionList = (result && result.result) || []
      } catch {
        this.regionList = []
      }
    },
  },
}
</script>
